import { render, staticRenderFns } from "./LoanRequest.vue?vue&type=template&id=2a778cde"
import script from "./LoanRequest.vue?vue&type=script&lang=js"
export * from "./LoanRequest.vue?vue&type=script&lang=js"
import style0 from "./LoanRequest.vue?vue&type=style&index=0&id=2a778cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports